import { defineAction } from '~/prix'
import { z } from 'zod'
import materialRequestUpdateAction from './materialRequestUpdate.action.json' with { type: 'json' }
import { materialRequestItemObject, materialRequestObject } from '../materialRequestObject'

const materialRequestUpdateDefinition = defineAction({
  ...materialRequestUpdateAction,
  input: materialRequestObject
    .pick({
      id: true,
      requestDate: true,
    })
    .partial({ requestDate: true })
    .extend({
      items: z
        .array(
          materialRequestItemObject
            .pick({
              id: true,
              materialId: true,
              requestedQuantity: true,
              unitMeasure: true,
            })
            .partial({ id: true, unitMeasure: true }),
        )
        .nullish(),
    }),
  output: z.object({}),
})

export default materialRequestUpdateDefinition
